import { Box, Button } from '@mui/material';

export default function StreamBillingChoice({
    annual,
    onPackages,
    onAnnual,
    annualDisabled = false,
    packagesDisabled = false,
    packagesLabel = 'Пакеты лидов',
}: {
    annual: boolean;
    onPackages: () => void;
    onAnnual: () => void;
    annualDisabled?: boolean;
    packagesDisabled?: boolean;
    packagesLabel?: string;
}) {
    return (
        <Box role="group" aria-label="Тип тарифа" sx={{ display: 'flex', width: { xs: '100%', sm: 'fit-content' }, borderBottom: '1px solid var(--lm-border)', mb: 2 }}>
            {([
                { label: packagesLabel, selected: !annual, onClick: onPackages, disabled: packagesDisabled },
                { label: 'Годовой безлимит', selected: annual, onClick: onAnnual, disabled: annualDisabled },
            ] as const).map(({ label, selected, onClick, disabled }) => (
                <Button
                    key={label}
                    type="button"
                    disableRipple
                    aria-label={label}
                    aria-pressed={selected}
                    disabled={disabled}
                    onClick={onClick}
                    sx={{
                        minHeight: 44,
                        flex: { xs: 1, sm: 'none' },
                        px: { xs: 1, sm: 2 },
                        borderBottom: '2px solid',
                        borderColor: selected ? 'var(--lm-accent)' : 'transparent',
                        borderRadius: 0,
                        bgcolor: 'transparent',
                        color: selected ? 'var(--lm-accent-ink)' : 'var(--lm-muted)',
                        fontWeight: selected ? 700 : 500,
                        textTransform: 'none',
                        '&:hover': { color: 'var(--lm-accent-ink)', bgcolor: 'transparent' },
                        '&:focus-visible': { outline: '2px solid var(--lm-accent)', outlineOffset: -2 },
                    }}
                >
                    {label}
                    {label === 'Годовой безлимит' && <Box component="span" aria-hidden="true" sx={{ ml: 0.75, color: 'var(--lm-success-ink)', fontSize: 12, fontWeight: 700 }}>(-30%)</Box>}
                </Button>
            ))}
        </Box>
    );
}
